<template>
	<el-container>
		<el-header class="title">
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/index/customer' }">客户管理</el-breadcrumb-item>
						<el-breadcrumb-item >{{customer.name}}</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main style="position: relative;padding: 10px;" v-loading="operating">
			<el-tabs v-model="activeName" type="border-card" class="card" @tab-click="tabOnClick">
				<el-tab-pane label="客户产品信息" name="customerproductinfo" :style="getStyleObject()" lazy>
					<div style="height: 40px;width: 100%;text-align: right;">
						<el-button-group >
							<el-button @click="popAddCustomerProductView()" class="group-btn" size="small" type="primary" icon="el-icon-plus">添加购买记录</el-button>
						</el-button-group>
					</div>
					<el-table :data="tableData" header-cell-class-name="table_header" border :height="tableHeight" rowKey="id" :stripe="true">
						<el-table-column prop="productName" label="产品" >
							<template slot-scope="scope">
								<el-link :underline="false" @click.native.prevent="">{{scope.row.productName}}</el-link>
							</template>
						</el-table-column>
						<el-table-column prop="productCategoryName" label="分类">
						</el-table-column>
						<el-table-column prop="portion" label="总份额">
						</el-table-column>
						<el-table-column prop="amount" label="总金额">
						</el-table-column>
						<el-table-column label="操作" width="120px">
							<template slot-scope="scope">
								<el-button size="mini" class="el-button--danger" @click="popCustomerRedeemPanel(scope.row)">赎回</el-button>
								<el-button size="mini" class="el-button--danger" icon="el-icon-delete" circle @click="deleteCustomerProduct(scope.row)"></el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="bottom-bar">
						<el-pagination @current-change="currentPageChangeHandler" background layout="total,prev, pager, next" :total="total" :page-size="pageSize">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="客户交易信息" name="customerproducttrade" :style="getStyleObject()"
										 rowKey="id" :stripe="true" lazy>
					<el-table :data="tradeTableData" header-cell-class-name="table_header" border :height="tableHeight" rowKey="id">
						<el-table-column prop="productName" label="产品名称" >
							<template slot-scope="scope">
								<el-link :underline="false" @click.native.prevent="">{{scope.row.productName}}</el-link>
							</template>
						</el-table-column>
						<el-table-column prop="productCategoryName" label="产品分类" width="200px">
						</el-table-column>
						<el-table-column prop="type" label="交易类型" :formatter="tradeTypeFormatter" width="100px">
						</el-table-column>
						<el-table-column prop="portion" label="交易份额" width="150px">
						</el-table-column>
						<el-table-column prop="amount" label="交易金额" width="150px">
						</el-table-column>
						<el-table-column prop="buyTime" label="交易日期" width="200px" :formatter="dateFormatter">
						</el-table-column>
						<el-table-column label="操作" width="150px">
							<template slot-scope="scope">
								<el-button size="mini" type="primary" @click="popEditCustomerProductPanel(scope.row)" circle icon="el-icon-edit"></el-button>
								<el-button size="mini" type="danger" @click="removeCustomerTradeLog(scope.row)" circle icon="el-icon-delete"></el-button>
							</template>
						</el-table-column>
					</el-table>
					<div class="bottom-bar">
						<el-pagination @current-change="currentTradePageChangeHandler" background layout="total,prev, pager, next" :total="tradeTotal" :page-size="pageSize">
						</el-pagination>
					</div>
				</el-tab-pane>
				<el-tab-pane label="客户基本信息" name="basicinfo" :style="getStyleObject()">
					<div class="edit-btn-group">
						<el-button @click="popEditCustomerPanel()" size="small" type="primary" icon="el-icon-edit">修改</el-button>
					</div>
					<el-form :model="customer"  label-width="120px" size="medium" :inline="true" label-suffix=" : ">
						<el-form-item label="姓名" prop="name" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.name}}</label>
						</el-form-item>
						<el-form-item label="手机" prop="phone" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.phone}}</label>
						</el-form-item>
						<el-form-item label="身份证号" prop="idcard" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.idcard}}</label>
						</el-form-item>
						<el-form-item label="Email" prop="email" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.email}}</label>
						</el-form-item>
						<el-form-item label="性别" prop="sex" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.sex==0?'未知':(customer.sex==1?'男':'女')}}<i :class="{'el-icon-male':customer.sex==1,'el-icon-female':customer.sex==2}" style="margin-left: 5px;font-weight: bold;"></i></label>
						</el-form-item>
						<el-form-item label="生日" prop="birthday" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.birthday}}</label>
						</el-form-item>
						<el-form-item label="地址" prop="address" style="width: 45%;" class="info-title">
							<label class="info-value">{{customer.address}}</label>
						</el-form-item>
						<el-form-item label="备注" prop="description" style="width: 90%;" class="info-title">
							<label class="info-value">{{customer.description}}</label>
						</el-form-item>
					</el-form>
				</el-tab-pane>
			</el-tabs>
		</el-main>
		<el-dialog title="修改客户信息" :visible.sync="showEditCustomerPanel">
			<edit-customer-panel :customer="editCustomer" @updatesuccess="updateCustomerSuccess"></edit-customer-panel>
		</el-dialog>
		<el-dialog title="添加购买记录" :visible.sync="showCustomerProductBuyPanel">
			<add-customer-product-buy-panel :customer="customer" @addcustomerproductsuccess="addCustomerProductSuccess"></add-customer-product-buy-panel>
		</el-dialog>
		<el-dialog title="添加赎回记录" :visible.sync="showCustomerProductRedeemPanel">
			<add-customer-product-redeem-panel :customer="customer" :redeem-customer-product="redeemCustomerProduct"
																				 @addcustomerproductredeemsuccess="addCustomerProductRedeemSuccess"></add-customer-product-redeem-panel>
		</el-dialog>
		<el-dialog title="修改交易记录" :visible.sync="showEditCustomerProductPanel">
			<edit-customer-product-panel :customer="customer" :customer-product="editCustomerProduct"
			@editcustomerproductsuccess="editCustomerProductSuccess"></edit-customer-product-panel>
		</el-dialog>
	</el-container>
</template>
<script>
	import config from "../../../config/global.js";
	import axios from "axios"
	import EditCustomerPanel from "./EditCustomerPanel.vue";
	import AddCustomerProductBuyPanel from "./AddCustomerProductBuyPanel.vue"
	import AddCustomerProductRedeemPanel from "./AddCustomerProductRedeemPanel.vue"
	import EditCustomerProductPanel from "./EditCustomerProductLogPanel.vue"

	export default {
		components: {
			AddCustomerProductRedeemPanel,
			EditCustomerPanel,AddCustomerProductBuyPanel,EditCustomerProductPanel
		},
		data() {
			return {
				activeName:"customerproductinfo",
				mainStyleObject:{
					"height":window.innerHeight-212+"px",
					"overflow-y":"auto",
					"box-sizing":"border-box"
				},
				tableHeight:window.innerHeight-285+"px",
				tableData:[],
				tradeTableData:[],
				customer:{},
				editCustomer:{},
				redeemCustomerProduct:{},
				editCustomerProduct:{},
				total:0,
				tradeTotal:0,
				pageSize:50,
				currentPageIndex:1,
				currentTradePageIndex:1,
				showEditCustomerPanel:false,
				showCustomerProductBuyPanel:false,
				showCustomerProductRedeemPanel:false,
				showEditCustomerProductPanel:false,
//				rules: {
//					name: [
//						{ required: true, message: '请输入姓名', trigger: 'blur' },
//						{ min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
//					],
//					phone: [
//						{ required: true, message: '请输入手机号码', trigger: 'blur' },
//						{ min: 11, max: 11, message: '长度在 11个字符', trigger: 'blur' }
//					],
//					sex: [
//						{ required: true, message: '请选择性别', trigger: 'blur' }
//					],
//					idcard: [
//						{ required: true, message: '请输入身份证号', trigger: 'blur' },
//						{ min: 15, max: 18, message: '长度在 15 到 18 个字符', trigger: 'blur' }
//					],
//					email:[
//						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
//					]
//					,
//					birthday:[
//
//					]
//					,
//					description:[
//						{ min: 1, max: 200, message: '长度在 1 到 200 个字符', trigger: 'blur' }
//					]
//				},
				operating:false,
				changed:false,
				firstchange:false
			}
		},
		props:{

		},
		methods:{
			getStyleObject:function () {
				return this.mainStyleObject;
			},
			tradeTypeFormatter:function (row, column, cellValue, index) {
				if(cellValue == 1){
					return "购买";
				}else if(cellValue == 2){
					return "赎回";
				}else{
					return "";
				}
			},
			getCustomer(id){
				axios({
					method: 'get',
					url:config.host+'/backend/customer/get.json?id='+id
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					if(response.data.result == 1){
						this.customer = response.data.object;
					}else{
						this.$alert(response.data.emsg, '请求失败', {
							confirmButtonText: '确定'
						});
					}
					this.operating = false;
				}).catch((error)=>{
					this.operating = false;
					this.$alert(error.response.statusText, '请求失败', {
						confirmButtonText: '确定'
					});
				})
			},
			getCustomerProduct:function (id) {
				var start = Math.max(0,(this.currentPageIndex-1)*this.pageSize);
				var size = this.pageSize;
				axios({
					method: 'post',
					url:config.host+'/backend/customer/product/list.json',
					data:{start,size,customerId:id}
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					this.tableData = response.data.items
					this.total = response.data.total
				})
					.catch((error)=>{
						console.log(error)
					})
			},
			getCustomerProductTradeInfo:function (id) {
				var start = Math.max(0,(this.currentTradePageIndex-1)*this.pageSize);
				var size = this.pageSize;
				axios({
					method: 'post',
					url:config.host+'/backend/customer/product/buylist.json',
					data:{start,size,customerId:id}
				}).then((response)=>{
					var defaultResult = this.responseDefaultHandle(response);
					if(defaultResult == false )
						return;
					this.tradeTableData = response.data.items
					this.tradeTotal = response.data.total
				})
					.catch((error)=>{
						console.log(error)
					})
			},
			close(){
				if(this.changed){
					this.$confirm('数据已更改，是否放弃修改?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.back();
					}).catch(() => {

					});
				}else{
					this.$router.back();
				}
			},
			currentPageChangeHandler:function (val) {
				this.currentPageIndex = val;
				this.getCustomerProduct(this.customer.id);
			},
			currentTradePageChangeHandler:function () {
				this.currentTradePageIndex = val;
				this.getCustomerProductTrade(this.customer.id);
			},
			popEditCustomerPanel:function () {
				this.editCustomer = JSON.parse(JSON.stringify(this.customer));
				this.showEditCustomerPanel = true;
			},
			updateCustomerSuccess:function () {
				this.getCustomer(this.$route.query.id);
				this.showEditCustomerPanel = false;
			},
			popAddCustomerProductView:function () {
				this.showCustomerProductBuyPanel = true;
			},
			addCustomerProductSuccess:function () {
				this.getCustomerProduct(this.customer.id);
				this.showCustomerProductBuyPanel = false;
			},
			popCustomerRedeemPanel:function (item) {
				this.redeemCustomerProduct = JSON.parse(JSON.stringify(item));
				this.showCustomerProductRedeemPanel = true;
			},
			deleteCustomerProduct:function (item) {
				this.$confirm('您确定要删除该客户产品信息吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					axios({
						method: 'post',
						url:config.host+"/backend/customer/deletebuy.json",
						data:item
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '已成功删除',
							type: 'success'
						});
						this.getCustomerProduct(this.customer.id);
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			addCustomerProductRedeemSuccess:function () {
				this.getCustomerProduct(this.customer.id);
				this.showCustomerProductRedeemPanel = false;
			},
			removeCustomerTradeLog:function (item) {
				this.$confirm('您确定要删除该交易记录吗？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning',
				}).then(()=>{
					axios({
						method: 'post',
						url:config.host+"/backend/customer/deletebuyrecord.json",
						data:item
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						this.$message({
							message: '已成功删除',
							type: 'success'
						});
						this.getCustomerProductTradeInfo(this.customer.id);
					})
						.catch((error)=>{
							console.log(error)
						})
				});
			},
			popEditCustomerProductPanel:function (item) {
				this.editCustomerProduct = JSON.parse(JSON.stringify(item));
				this.showEditCustomerProductPanel = true;
			},
			//修改购买记录成功后调用
			editCustomerProductSuccess:function () {
				this.showEditCustomerProductPanel = false;
				this.getCustomerProductTradeInfo(this.customer.id);
			},
			tabOnClick:function (tab) {
				if(this.activeName == "customerproducttrade"){
					this.getCustomerProductTradeInfo(this.$route.query.id);
				}
			},
			dateFormatter:function (row, column,cellValue,index) {
				if(cellValue.length>10){
					return cellValue.substring(0,10);
				}else{
					return cellValue;
				}
			},
		},
		mounted:function(){
			this.getCustomer(this.$route.query.id);
			this.getCustomerProduct(this.$route.query.id);
		},
		watch:{
			customer:{
				handler:function(){
					if(this.firstchange){
						this.changed = true;
					}
					this.firstchange = true;
				},
				deep:true
			}
		}
	}
</script>
<style scoped>
	.tl{
		text-align: left;
	}
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}

	.edit-btn-group{
		position: absolute;
		right: 30px;
		top: 10px;
	}

	.info-title{
		font-size: 15px;
	}

	.info-value{
		font-size: 13px;
		color: #606266;
	}

	.bottom-bar{
		text-align:right;
		height: 32px;
		background:#F5F7FA;
		position: absolute;
		bottom: 0px;
		right:0px;
		left: 0px;
		text-align: right;
		border-radius: 0 0 5px 5px;
		padding: 5px 10px;
		z-index: 999;
		border-top: 1px solid #DCDFE6;
	}

</style>



// WEBPACK FOOTER //
// src/layouts/customer/ViewCustomer.vue